<template>
    <div>
        <div class="order-index">
            <van-nav-bar title="充值记录" @click-left="onClickLeft" left-text="返回" left-arrow></van-nav-bar>
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    :error.sync="error"
                    error-text="请求失败，点击重新加载"
                    @load="loadData"
            >
                <van-cell
                        v-for="item in list"
                        :key="item.id"
                        style="background: #f4f4f4;margin: 10px 2%;box-shadow: 1px 1px 4px #666;width: 96%;border-radius: 4px;padding: 0 0 0 0"
                >
                    <template slot>
                        <div style="padding: 4px;
                        background: -webkit-gradient(linear, right top, left top, from(#3c6bff), to(#a5c4f9));
                        background: linear-gradient(180deg, #3c6bff, #a5c4f9);">
                        <div style="color: #fff; ">卡号：{{item.iccid}}
                        </div>
                            <div class="content" style="padding: 10px 0">
                            <div class="title" style="display: flex;position: relative">
                                <div>单号：{{item.order_sn}}</div>
                                <div style="right: 0;position: absolute">
                                    <strong v-if="item.send_status==1" style="color: #07c160">充值成功</strong>
                                    <strong v-else style="color: #2f86f6">等待充值</strong>
                                </div>
                            </div>

                                <div style="display: flex;position: relative;">
                                    <div style="font-weight: bold;color: #666;">
                                        {{item.package.title}}-{{item.package.typeID==1? '基础套餐':'叠加套餐'}}
                                    </div>
                                    <div style="right: 0;position: absolute;font-weight: bold;color: #ee0a24;">
                                        &yen;{{item.price}}
                                    </div>
                                </div>
                                <div style="text-align: right">有效期 <strong>{{item.startDate}}</strong> 至 <strong>{{item.endDate}}</strong>
                                </div>
                            </div>
                        </div>
                    </template>
                </van-cell>

            </van-list>
        </div>
    </div>
</template>

<script>
    export default {
        name: "order",
        data() {
            return {
                loading: true,
                finished: false,
                error: false,
                list: []
            };
        },
        methods: {
            loadData() {
                this.error = false;
                this.fetchData('/order/index', {iccid: sessionStorage.getItem('iccid')}, (res) => {
                    this.loading = false;
                    if (res.code) {
                        this.list = res.data.data;
                        if (res.data.current_page >= res.data.last_page) {
                            this.finished = true;
                        }
                    } else {
                        this.error = true
                    }
                })
            }
        },
        created: function () {
            this.loadData();
        }
    };
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/order.vue